// @flow
import { useMemo } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import KpiService from '../../services/kpiService';

const DEFAULT_BUCKETS = {
  lateRecerts: 0,
  under30: 0,
  between31And60: 0,
  between61And90: 0,
  between90And120: 0,
  upcoming: 0,
};

const useComplianceOverviewCountsQuery = ({
  organizationId,
  includeNotStartedCerts,
  filter,
  searchText,
  options,
}: {
  organizationId: string,
  includeNotStartedCerts?: boolean,
  filter?: Object,
  searchText?: string,
  options?: UseQueryOptions,
}) => {
  const isQueryEnabled = options?.enabled ?? true;

  const { data, isLoading, isFetching } = useQuery(
    [
      'useComplianceOverviewCountsQuery',
      organizationId,
      includeNotStartedCerts,
      filter,
      searchText,
    ],
    async ({ signal } = {}) => {
      const requestOptions = signal ? { signal } : undefined;
      return new KpiService().getComplianceOverviewCounts(
        organizationId,
        includeNotStartedCerts,
        { filter, searchText },
        requestOptions,
      );
    },
    {
      enabled: Boolean(organizationId && isQueryEnabled),
      staleTime: 60000,
      refetchOnWindowFocus: false,
      retry: false,
      ...options,
    },
  );

  const buckets = useMemo(() => data?.buckets ?? DEFAULT_BUCKETS, [data]);

  return {
    buckets,
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isFetching,
  };
};

export default useComplianceOverviewCountsQuery;
